module.exports = __webpack_public_path__ + "2d8a7b83b1389acb9f84a9dc26cafcbf.jpg";